<template>
  <div class="vuestic-file-upload-undo">
    {{ $t('fileUpload.fileDeleted') }}
    <button type="button"
            class="btn-text btn-text--primary"
            @click="$emit('recover')">
      {{ "Ponistu upload" }}?
    </button>
  </div>
</template>

<script>
export default {
  name: 'vuestic-file-upload-undo',
}
</script>



// WEBPACK FOOTER //
// src/components/labassays/vuestic-datatable/upload/AssayFileUploadUndo.vue